<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Side view template for LogicFlow OBC — compact overview with status, versioning actions, CRUD form, flow designer, and tests.
-->
@if (initialized && dto) {
    <div class="grid">
        <div class="col-12">

            @if (activeNavigationItem?.action === 'overview') {
                <div class="p-3">
                    <div class="flex flex-column gap-3">
                        <div class="flex align-items-center gap-2">
                            <p-tag [value]="flowStatusLabel" [severity]="flowStatusSeverity" [icon]="flowStatusIcon"></p-tag>
                            <span class="text-color-secondary text-sm">Version {{ flowVersion }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            @if (flowStatus === LogicFlowStatusEnum.DRAFT) {
                                <p-button label="Veröffentlichen" icon="fa-regular fa-check" severity="success" size="small" (onClick)="publishFlow()" [loading]="publishing"></p-button>
                            }
                            @if (flowStatus === LogicFlowStatusEnum.PUBLISHED) {
                                <p-button label="Neue Version" icon="fa-regular fa-copy" severity="info" size="small" (onClick)="createNewVersion()" [loading]="creatingVersion"></p-button>
                            }
                            <p-button label="Exportieren" icon="fa-regular fa-download" [text]="true" size="small" (onClick)="exportFlow()"></p-button>
                        </div>
                        <!-- AI: CRUD Object Component for LogicFlow overview -->
                        <mvs-crud-object
                                [objectType]="objectIdentifier.objectType"
                                [objectId]="objectIdentifier.objectId"
                                (onChangedObject)="loadData()">
                        </mvs-crud-object>
                    </div>
                </div>
            }

            @if (activeNavigationItem?.action === 'designer') {
                <!-- TM-1000001563: [flowImports]/[flowExports] pass declared schema to Start/End cards -->
                <!-- TM-1000001563: removed `(editStep)` consumer hookup — the
                     designer no longer emits `editStep` (its `(dblclick)`
                     source was deleted in Item 1). -->
                <!-- TM-1000001563: [flowId] enables backend layout persistence; -->
                <!-- TM-1000001563: [layoutJson] feeds the saved layout synchronously
                     so the canvas seeds with persisted positions on first paint
                     (parent OBC already has `dto` with layoutJson loaded). -->
                <lg-flow-designer
                        [steps]="flowSteps"
                        [flowId]="objectIdentifier?.objectId"
                        [layoutJson]="dto?.layoutJson"
                        [resolvedSteps]="resolvedFlow?.steps"
                        [overrideMap]="resolvedFlow?.overrideMap"
                        [readonly]="isPublished"
                        [flowImports]="flowImportsList"
                        [flowExports]="flowExportsList"
                        (selectedStep)="onFlowStepSelected($event)">
                </lg-flow-designer>
            }

            @if (activeNavigationItem?.action === 'tests') {
                <mvs-lg-test-runner
                        [flowId]="objectIdentifier.objectId">
                </mvs-lg-test-runner>
            }

        </div>
    </div>
}

<!-- TM-1000001563: Removed duplicate <p-confirmDialog/>; relying on the global instance in app.main.component.html -->

